import { GlobalSnackbar } from '@components/feedback/GlobalSnackbar';
import { GlobalSearchBar } from '@components/ui/GlobalSearchBar';
import { Box, Typography } from '@mui/material';
import { useAppShellStore } from '@store/appShellStore';
import { Outlet } from 'react-router-dom';

import { AppShellSkeleton } from './AppShellSkeleton';
import { PAGE_MAX_WIDTH, PAGE_PX, TOPBAR_HEIGHT } from './layoutMetrics';
import { Topbar } from './Topbar';


export const MainLayout = () => {
  const { shellReady } = useAppShellStore();

  // Centre / main-centre switches hard-reload the app, so this runs on every
  // scope change — show the shell taking shape rather than a blank spinner.
  if (!shellReady) return <AppShellSkeleton />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'white', overflowX: 'hidden' }}>
      <Topbar />
      <Box
        component="main"
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: PAGE_MAX_WIDTH,
          mx: 'auto',
          px: PAGE_PX,
          pt: `calc(${TOPBAR_HEIGHT} + 25px)`,
          pb: '25px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <GlobalSearchBar />
        <Outlet />
      </Box>
      <Box
        component="footer"
        sx={(theme) => ({
          borderTop: `1px solid ${theme.palette.slate[200]}`,
          pt: '13px',
          pb: '12px',
          px: PAGE_PX,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          bgcolor: 'white',
          flexShrink: 0,
        })}
      >
        <Typography sx={(theme) => ({ fontSize: '12px', fontWeight: 500, color: theme.palette.grey[400], lineHeight: '20px' })}>
          © {new Date().getFullYear()} Shri Ji Complete Educational Solutions. All rights reserved.
        </Typography>
      </Box>
      <GlobalSnackbar />
    </Box>
  );
};
